import { Moon, Sun } from '@argus/ui/icons';

import { resolveTheme, useTheme } from '../lib/theme.ts';
import { Button } from './ui.tsx';

/**
 * Sun/moon theme switch for the portal top bar (F-36, Flow 32). Mirrors the web app's
 * user-menu item: flips between the two explicit themes from whatever `system` resolves
 * to. The shared ghost icon button + the shared `Sun` / `Moon` glyphs (Solar Bold — PO
 * rulings 2026-09-23 Solar in both apps; 2026-10-05 filled by default — a toolbar button is
 * chrome, not wayfinding).
 */
export function ThemeToggle(): JSX.Element {
  const theme = useTheme((s) => s.theme);
  const setTheme = useTheme((s) => s.setTheme);
  const resolved = resolveTheme(theme);
  const dark = resolved === 'dark';
  const label = dark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <Button
      variant="ghost"
      iconOnly
      aria-label={label}
      title={label}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
      icon={dark ? <Sun size={16} aria-hidden="true" /> : <Moon size={16} aria-hidden="true" />}
    />
  );
}
